import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getAllProjectWithoutAllocation } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { ProjectsWithoutAllocationsDto } from "../../../../../@types/widgets.type";
import { IconProjectsWithoutAllocations } from "../../../../../icons/IconProjectsWithoutAllocations";
import { ProjectStatusService } from "../../../../../services/api/projectStatus/ProjectStatusService";
import { IKeyValue } from "../../../../../@types/key-value.type";
import styles from "./styles.module.scss";

interface ProjectsWithoutAllocationsProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "projectName",
    headerName: "Projeto",
    flex: 1,
  },
  {
    field: "projectManager",
    headerName: "Gestor",
    flex: 1,
  },
  {
    field: "projectStatus",
    headerName: "Status",
    flex: 1,
  },
];

export function ProjectsWithoutAllocations({
  chart,
  deleteChart,
  ismodeEdit,
}: ProjectsWithoutAllocationsProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const [projectStatus, setProjectStatus] = useState<IKeyValue[]>([]);

  const user = storageUserGet();

  async function fetchProjectWithoutAllocation(params: IGetRowsParams) {
    try {
      setLoading(true);
      let projectStatusIds: string[] = [];

      if (projectStatus?.length === 0) {
        const responseStatus =
          (await ProjectStatusService.getAllProjectStatusIdsAndNames()) as IKeyValue[];

        setProjectStatus(responseStatus);
        projectStatusIds = responseStatus.map((status) => status.key) ?? [];
      }

      const paramsBody = {
        skip: params.startRow,
        take: params.endRow - params.startRow,
        projectStatusIds,
        userEmail: user.email,
        resourceId: user?.resourceId as string,
      };

      const response = (await getAllProjectWithoutAllocation(
        paramsBody
      )) as IApiResponse<ProjectsWithoutAllocationsDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.items,
          response.result.totalRows
        );
      } else {
        params.failCallback();
      }
    } catch (error) {
      console.error("Erro ao buscar projetos sem alocação:", error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconProjectsWithoutAllocations size={24} />
          Projetos sem Alocação no Mês
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchProjectWithoutAllocation}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
